// Size Validator - Fixed for Shopify Custom Measurements
(function() {
  'use strict';

  console.log("🔍 SIZE VALIDATOR STARTING...");

  // State management
  window.validatorState = {
    initialized: false,
    constraints: { maxWidth: 92, maxLength: 200 },
    currentUnit: "cm",
    selectedSize: "single",
    dimensionInputs: { width: null, length: null }
  };

  // Size constraints mapping
  const sizeConstraints = {
    'single': { maxWidth: 92, maxLength: 200 },
    'double': { maxWidth: 137, maxLength: 200 },
    'king': { maxWidth: 152, maxLength: 200 },
    'super-king': { maxWidth: 183, maxLength: 200 }
  };

  // Enhanced validateInput function that respects current unit
  window.validateInput = function(input, dimension) {
    console.log("🔍 VALIDATE CALLED:", dimension, "value:", input.value, "current unit:", window.validatorState.currentUnit);
    
    const value = input.value.trim();
    if (!value) return true;
    
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue <= 0) {
      console.log("🔍 INVALID NUMBER");
      showError(input, "Please enter a valid positive number");
      return false;
    }
    
    // Get constraints in CM (base unit)
    const constraintsCm = window.validatorState.constraints;
    const selectedSize = window.validatorState.selectedSize;
    const currentUnit = window.validatorState.currentUnit;
    
    // Convert constraints to current unit
    let maxWidth, maxLength;
    if (currentUnit === 'mm') {
      maxWidth = constraintsCm.maxWidth * 10; // Convert cm to mm
      maxLength = constraintsCm.maxLength * 10;
    } else if (currentUnit === 'in') {
      maxWidth = constraintsCm.maxWidth * 0.393701; // Convert cm to inches
      maxLength = constraintsCm.maxLength * 0.393701;
    } else {
      maxWidth = constraintsCm.maxWidth; // Already in cm
      maxLength = constraintsCm.maxLength;
    }
    
    if (dimension === "width") {
      if (numValue > maxWidth) {
        console.log(`🔍 WIDTH TOO BIG: ${numValue}${currentUnit} > ${maxWidth}${currentUnit}`);
        showError(input, `Width cannot exceed ${Math.round(maxWidth)}${currentUnit} for ${selectedSize} size`);
        return false;
      }
    } else if (dimension === "length") {
      if (numValue > maxLength) {
        console.log(`🔍 LENGTH TOO BIG: ${numValue}${currentUnit} > ${maxLength}${currentUnit}`);
        showError(input, `Length cannot exceed ${Math.round(maxLength)}${currentUnit}`);
        return false;
      }
    }
    
    console.log("🔍 VALIDATION PASSED");
    clearError(input);
    return true;
  };

  // Function to detect current unit from toggle buttons
  function getCurrentUnit() {
    const activeButton = document.querySelector('.cm-unit-btn.active');
    if (activeButton) {
      const unit = activeButton.getAttribute('data-unit') || activeButton.textContent.trim().toLowerCase();
      console.log("🔍 DETECTED CURRENT UNIT:", unit);
      return unit;
    }
    console.log("🔍 NO ACTIVE UNIT BUTTON FOUND, defaulting to cm");
    return 'cm';
  }

  // Function to watch for unit changes
  function watchForUnitChanges() {
    const unitButtons = document.querySelectorAll('.cm-unit-btn');
    console.log(`🔍 WATCHING ${unitButtons.length} UNIT BUTTONS FOR CHANGES`);
    
    unitButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Small delay to ensure the active class has been updated
        setTimeout(() => {
          const newUnit = getCurrentUnit();
          console.log(`🔍 UNIT CHANGED TO: ${newUnit}`);
          window.validatorState.currentUnit = newUnit;
          
          // Re-validate any inputs that have values
          if (window.validatorState.dimensionInputs.width && window.validatorState.dimensionInputs.width.value) {
            validateInput(window.validatorState.dimensionInputs.width, 'width');
          }
          if (window.validatorState.dimensionInputs.length && window.validatorState.dimensionInputs.length.value) {
            validateInput(window.validatorState.dimensionInputs.length, 'length');
          }
        }, 100);
      });
    });
  }

  // Enhanced showError function with CSS classes
  window.showError = function(input, message) {
    console.log(`🔍 SHOW ERROR CALLED: ${message}`);
    
    // Add error class
    input.classList.add("msv-input--error");
    
    // Create tooltip
    let tooltip = input.parentElement.querySelector('.msv-error-tooltip');
    if (!tooltip) {
      console.log("🔍 CREATING NEW TOOLTIP");
      tooltip = document.createElement('div');
      tooltip.className = 'msv-error-tooltip';
      input.parentElement.style.position = 'relative';
      input.parentElement.appendChild(tooltip);
    }
    tooltip.textContent = message;
    tooltip.style.display = 'block';
    console.log("🔍 TOOLTIP CREATED/UPDATED");
  };

  // Clear error function
  window.clearError = function(input) {
    console.log("🔍 CLEAR ERROR CALLED");
    input.classList.remove("msv-input--error");
    const tooltip = input.parentElement.querySelector('.msv-error-tooltip');
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  };

  // Size detection functions
  function detectSizeFromUrl() {
    const url = window.location.href.toLowerCase();
    if (url.includes('single') || url.includes('3ft')) return 'single';
    if (url.includes('super-king') || url.includes('6ft')) return 'super-king';
    if (url.includes('king') || url.includes('5ft')) return 'king';
    if (url.includes('double') || url.includes('4ft-6')) return 'double';
    return null;
  }

  function detectSizeFromProduct() {
    // Method 1: Check URL
    const urlDetected = detectSizeFromUrl();
    if (urlDetected) {
      console.log("🔍 Size detected from URL:", urlDetected);
      return urlDetected;
    }
    
    // Method 2: Check product title/heading
    const productTitle = document.querySelector('h1, .product-title, .product__title, .product__title--large');
    if (productTitle) {
      const titleText = productTitle.textContent.toLowerCase();
      if (titleText.includes('single') || titleText.includes('3ft')) return 'single';
      if (titleText.includes('super king') || titleText.includes('6ft')) return 'super-king';
      if (titleText.includes('king') || titleText.includes('5ft')) return 'king';
      if (titleText.includes('double') || titleText.includes('4ft 6')) return 'double';
    }
    
    // Method 3: Check page content
    const pageContent = document.body.textContent.toLowerCase();
    if (pageContent.includes('single mattress') || pageContent.includes('3ft mattress')) {
      return 'single';
    }
    
    console.warn("🔍 Could not detect mattress size - defaulting to single");
    return 'single';
  }

  function updateValidatorForSize(size) {
    console.log("🔍 Updating validator for size:", size);
    
    if (sizeConstraints[size]) {
      window.validatorState.constraints = sizeConstraints[size];
      window.validatorState.selectedSize = size;
      console.log("🔍 New constraints:", window.validatorState.constraints);
      
      // Re-validate existing inputs
      if (window.validatorState.dimensionInputs.width && window.validatorState.dimensionInputs.width.value) {
        validateInput(window.validatorState.dimensionInputs.width, 'width');
      }
      if (window.validatorState.dimensionInputs.length && window.validatorState.dimensionInputs.length.value) {
        validateInput(window.validatorState.dimensionInputs.length, 'length');
      }
    }
  }

  // Emergency override function for testing
  function forceMattressSize(size) {
    console.log("🔧 FORCE SETTING mattress size to:", size);
    updateValidatorForSize(size);
  }
  window.forceMattressSize = forceMattressSize;

  // Professional input validation setup
  function setupInputValidation(input, dimension) {
    let typingTimer;
    const typingDelay = 800;
    
    console.log(`🔍 Setting up validation for ${dimension} input`);
    
    // INPUT EVENT: Validate while typing (but don't show errors immediately)
    input.addEventListener('input', function(e) {
      clearTimeout(typingTimer);
      
      // Clear errors while typing if field becomes empty
      if (this.value.trim() === '') {
        clearError(this);
      }
      
      // Set timer to validate after user stops typing
      typingTimer = setTimeout(() => {
        if (this.value.trim() !== '') {
          validateInput(this, dimension);
        }
      }, typingDelay);
    });
    
    // BLUR EVENT: Always validate when user leaves field
    input.addEventListener('blur', function(e) {
      clearTimeout(typingTimer);
      if (this.value.trim() !== '') {
        validateInput(this, dimension);
      }
    });
    
    // FOCUS EVENT: Clear errors when user focuses back
    input.addEventListener('focus', function(e) {
      clearError(this);
    });
    
    console.log(`🔍 Validation setup complete for ${dimension}`);
  }

  // Hook into existing reset button functionality
  function setupResetButtonIntegration() {
    const resetButton = document.querySelector('.cm-reset-btn');
    if (resetButton) {
      console.log("🔍 HOOKING INTO EXISTING RESET BUTTON");
      
      // Listen for reset button clicks and clear all errors
      resetButton.addEventListener('click', function() {
        console.log("🔍 RESET BUTTON CLICKED - CLEARING ALL ERRORS");
        
        // Clear all error states from our validator
        const inputs = document.querySelectorAll('.cm-custom-input');
        inputs.forEach(input => {
          clearError(input);
        });
      });
    }
  }

  // Also clear errors when inputs are programmatically cleared
  function watchForInputClears() {
    const inputs = document.querySelectorAll('.cm-custom-input');
    inputs.forEach(input => {
      // Use MutationObserver to watch for value changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            if (input.value === '' || input.value === null) {
              console.log("🔍 INPUT CLEARED PROGRAMMATICALLY - CLEARING ERROR");
              clearError(input);
            }
          }
        });
      });
      
      observer.observe(input, { attributes: true, attributeFilter: ['value'] });
      
      // Also watch for input events that clear the field
      input.addEventListener('input', function() {
        if (this.value === '') {
          clearError(this);
        }
      });
    });
  }

  // Main initialization function
  function initializeValidator() {
    console.log("🔍 LOOKING FOR CUSTOM MEASUREMENT INPUTS...");
    
    // Wait for custom measurements panel to be open
    const measurementPanel = document.querySelector('.cm-option-group[data-cm-option="provide_now"]');
    if (!measurementPanel) {
      console.log("🔍 Measurement panel not found, retrying...");
      setTimeout(initializeValidator, 1000);
      return;
    }
    
    // Look for inputs within the measurement panel
    const inputs = measurementPanel.querySelectorAll('.cm-custom-input');
    console.log(`🔍 FOUND ${inputs.length} CUSTOM INPUTS:`, inputs);
    
    if (inputs.length >= 2) {
      // Store dimension inputs - assume first two are width and length
      window.validatorState.dimensionInputs = {
        width: inputs[0],
        length: inputs[1]
      };
      
      console.log("🔍 SETTING UP PROFESSIONAL VALIDATION...");
      
      // Set up validation for each input
      setupInputValidation(inputs[0], 'width');
      setupInputValidation(inputs[1], 'length');
      
      // Set up reset button integration
      setupResetButtonIntegration();
      
      // Watch for programmatic input clearing
      watchForInputClears();
      
      // IMPORTANT: Detect and sync with current unit
      window.validatorState.currentUnit = getCurrentUnit();
      console.log("🔍 SYNCED WITH CURRENT UNIT:", window.validatorState.currentUnit);
      
      // Watch for unit toggle changes
      watchForUnitChanges();
      
      // Detect mattress size immediately
      const detectedSize = detectSizeFromProduct();
      if (detectedSize) {
        console.log("🔍 Immediately detected size:", detectedSize);
        updateValidatorForSize(detectedSize);
      }
      
      // Mark as initialized
      window.validatorState.initialized = true;
      
      console.log('✅ SIZE VALIDATOR SETUP COMPLETE!');
      return true;
    } else {
      console.log("❌ NOT ENOUGH INPUTS FOUND, RETRYING...");
      setTimeout(initializeValidator, 1000);
      return false;
    }
  }

  // Watch for the measurement panel to open
  function watchForPanelOpen() {
    console.log("🔍 WATCHING FOR MEASUREMENT PANEL TO OPEN...");
    
    const measurementDetails = document.querySelector('.cm-option-group[data-cm-option="provide_now"]');
    if (measurementDetails) {
      // Watch for the details element to open
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (measurementDetails.hasAttribute('open') && !window.validatorState.initialized) {
              console.log("🔍 MEASUREMENT PANEL OPENED - INITIALIZING VALIDATOR");
              setTimeout(initializeValidator, 200); // Small delay to ensure DOM is ready
            }
          }
        });
      });
      
      observer.observe(measurementDetails, { attributes: true });
      
      // Also check if it's already open
      if (measurementDetails.hasAttribute('open')) {
        console.log("🔍 MEASUREMENT PANEL ALREADY OPEN - INITIALIZING VALIDATOR");
        setTimeout(initializeValidator, 200);
      }
      
      console.log("🔍 PANEL WATCHER SET UP");
    } else {
      console.log("🔍 MEASUREMENT DETAILS NOT FOUND, RETRYING...");
      setTimeout(watchForPanelOpen, 1000);
    }
  }

  // Start initialization
  console.log("🔍 DOCUMENT STATE:", document.readyState);
  
  if (document.readyState === 'loading') {
    console.log("🔍 WAITING FOR DOM...");
    document.addEventListener('DOMContentLoaded', watchForPanelOpen);
  } else {
    console.log("🔍 DOM READY, STARTING WATCHER...");
    watchForPanelOpen();
  }

  // Backup initialization
  setTimeout(() => {
    console.log("🔍 BACKUP INITIALIZATION...");
    if (!window.validatorState.initialized) {
      initializeValidator();
    }
  }, 3000);

})();